import Media from './media';
import Richtext from './richtext';
import Location from './location';
import AccordionConfig from './accordion-config';

export default class LocationsMap {
  backgroundColor?: string;
  description?: Richtext;
  markerIcon?: Media;
  selectedMarkerIcon?: Media;
  mapDefaultCenter?: any;
  mapDefaultZoom?: number;
  searchIcon?: Media;
  searchLabel?: string;
  title?: Richtext;
  locationsList?: Location[];
  locationsListTitle?: string;
  noResultsMessage?: Richtext;
  accordionConfig: AccordionConfig;
  dynamicSection?: string;

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.description = props.description
      ? new Richtext(props.description)
      : undefined;
    this.title = props.title ? new Richtext(props.title) : undefined;
    this.markerIcon = props.markerIcon
      ? new Media(props.markerIcon)
      : undefined;
    this.selectedMarkerIcon = props.selectedMarkerIcon
      ? new Media(props.selectedMarkerIcon)
      : undefined;
    this.mapDefaultCenter = props.mapDefaultCenter;
    this.mapDefaultZoom = props.mapDefaultZoom || 11;
    this.searchLabel = props.searchLabel;
    this.searchIcon = props.searchIcon
      ? new Media(props.searchIcon)
      : undefined;
    this.locationsList =
      props.locationsList && props.locationsList.locations
        ? props.locationsList.locations.map(
            (location: any) => new Location(location)
          )
        : undefined;
    this.locationsListTitle = props.locationsListTitle;
    this.noResultsMessage = props.noResultsMessage
      ? new Richtext(props.noResultsMessage)
      : undefined;
    this.accordionConfig = new AccordionConfig(props.accordionConfig || {});
    this.dynamicSection = props.dynamicSection;
  }
}
